export default {
  name: 'English',
  navigation: {
    home: 'Home',
    productSystem: 'Product System',
    groupMembers: 'Group Members',
    devHistory: 'Dev History',
    onlineMall: 'Online Mall',
    enterpriseNews: 'Enterprise News',
    mediaReports: 'Media Reports',
    historyMedia: 'History Media',
    contactUs: 'Contact Us',
    productSystem2: 'PRODUCT SYSTEM',
    groupMembers2: 'GROUP MEMBERS',
    devHistory2: 'DEVELOPMENT HISTORY',
    onlineMall2: 'ONLINE MALL',
    enterpriseNews2: 'ENTERPRISE NEWS',
    contactUs2: 'CONTACT US'
  },
  companyName: 'Fujian Guangyang Egg Industry Co., Ltd.',
  addressName: 'ADDRESS',
  address: 'No. 52, Chaoyang Road, Moshi Village, Jingyang Town, Fuqing City, Fuzhou City, Fujian Province',
  goal1: 'Aim for world-class',
  goal2: 'Achieve world-class',
  copyright: 'All Rights Reserved.',
  recordName: 'Min ICP Bei 05001758-2',
  detail: 'Detail',
  newsDetails: 'NEWS DETAIL',
  viewOriginalText: 'Original Article',
  back: 'Back',
  contactNumber: 'CONTACT NUMBER',
  contactEmail: 'CONTACT EMAIL',
  searchReport: 'Search news...',
  share: 'Share',
  copySuccess: 'Link copied',
  copyFail: 'Unable to share',
  albumName: 'Guangyang Egg Industry Album'
}
